import React from "react";
import classes from "./style.module.scss";
import classNames from "classnames";
import { Dialog, Grow } from "@mui/material";

export const CloseDialog = ({ closeActions, className }) => (
    <div className={classNames(classes.close, { [className]: className })} onClick={() => closeActions()}>
        <div>
            <span>close</span>
        </div>
    </div>
);

const getClasses = ({ rootClass = "", paperClass = "" }) => ({
    root: `${classes.dialogRoot} ${rootClass ? rootClass : ""}`,
    paper: `${classes.paper} ${paperClass ? paperClass : ""}`,
});

export default React.memo(({ children, classes = {}, closeActions = () => {}, open = false, ...props }) => (
    <Dialog
        onClose={(event, reason) => {
            if (reason === "backdropClick" && closeActions) closeActions();
        }}
        disableEnforceFocus
        open={open}
        onKeyDown={(event) => {
            if (props.actionkey && closeActions) {
                if (event.key === props.actionkey) {
                    closeActions();
                }
            }
        }}
        classes={getClasses(classes)}
        TransitionComponent={Grow}
        transitionDuration={450}
        {...props}
    >
        {children}
    </Dialog>
));
